/**
 * Created by kldavis on 2/23/17.
 */
var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.DynamicScriptLoaderRun = new Class({
    class_type: "DynamicScriptLoaderRun",
    class_name: "DynamicScriptLoaderRun",
    Implements: [new Class(OCS.Interfaces.UniqueId), Chain, Events, Options, Class.Thenable],
    ajax_manager: null,
    options: {
        'job_id': '',
        'loaded': [], // An array of already loaded scripts
        'load': [], // An array of scripts that are to be loaded.
        'prepend': false, // Wether or not we prepend the script in the header or append it to the list
        'debug': false, // Display the debug related prompts,
        'use_ajax': false // Use ajax to request js scripts and blob them into the dom
    },
    initialize: function (op) {
        this.setOptions(op);
        if (this.options.debug) {
            console.debug(this.class_name + ": Created with options, ", op);
        }
        this.addEvent('complete_run', this.destroy.bind(this));
    },
    start: function () {
        this.load_scripts(this.options.load);
        return this;
    },
    load_scripts: function (urls) {
        if (this.is_finished) {
            return;
        }

        // Load the scripts one at a time in order.
        var next_url = this.get_next_url(urls);
        if (next_url) {
            this.load_single_script(next_url);
        } else {
            // No more scripts to load, complete the run
            this.complete_run();
        }
    },
    get_next_url: function (url_array) {
        var next_url;
        url_array.forEach(function (url) {
            if (!next_url && !this.is_script_loaded(url) && !OCS.DynamicScriptLoader.job_manager.is_script_finished_loaded(url)) {
                next_url = url;
                return;
            }
        }.bind(this));
        return next_url;
    },
    load_single_script: function (script_url) {
        var req, job_id, type, internal_url, dom_element;
        if (!script_url) {
            return;
        }
        if (this.is_script_loaded(script_url) || OCS.DynamicScriptLoader.job_manager.is_script_finished_loaded(script_url)) {
            this.script_loaded(script_url);
            return;
        }
        if (OCS.DynamicScriptLoader.job_manager.is_script_requested(script_url)) {
            return;
        }
        job_id = this.options.job_id;

        // Script load now may proceed
        if (script_url.indexOf('.js') > -1) {
            dom_element = document.createElement("script");
            type = "text/javascript";
        }
        if (script_url.indexOf('.css') > -1) {
            dom_element = document.createElement("link");
            dom_element.setAttribute("rel", "stylesheet");
            type = "text/css";
        }
        dom_element.setAttribute("type", type);

        if (this.options.debug) {
            dom_element.className = this.class_name + ' ' + job_id;
        }
        var head = document.getElementsByTagName("head")[0];
        if (this.options.hasOwnProperty('prepend') && this.options.prepend) {
            head.insertBefore(dom_element, head.firstChild);
        } else {
            head.appendChild(dom_element);
        }

        if (script_url.indexOf('.js') > -1) {
            if (this.options.use_ajax) {
                this.request_ajax_js(script_url, dom_element);
            } else {
                this.request_js(script_url, dom_element);
            }
        }
        if (script_url.indexOf('.css') > -1) {
            this.request_css(script_url, dom_element);
        }

        return;
    },
    request_css: function (script_url, dom_element) {
        dom_element.setAttribute("href", script_url);
        this.script_loaded(script_url, dom_element);
    },
    request_js: function (script_url, dom_element) {
        if (dom_element.readyState) {  //IE
            dom_element.onreadystatechange = function () {
                if (dom_element.readyState === "loaded" || dom_element.readyState === "complete") {
                    dom_element.onreadystatechange = null;
                    this.script_loaded(script_url, dom_element);
                }
            }.bind(this);
        } else {  //Others
            dom_element.onload = function () {
                this.script_loaded(script_url, dom_element);
            }.bind(this);
        }

        dom_element.setAttribute("src", script_url);

    },
    request_ajax_js: function (script_url, dom_element) {
        var internal_url;
        var script_retrieved = function (resp) {
            if (resp) {
                var blob = new Blob([resp.text], {'type': "text/javascript"});
                internal_url = window.URL.createObjectURL(blob);
                dom_element.setAttribute("src", internal_url);
                this.script_loaded(script_url, dom_element);
            }
        }.bind(this);

        // Make an ajax request for it
        var am = this.get_ajax_manager();
        var req = am.request(script_url, {url: script_url});
        req.addEvent('success', script_retrieved);
        req.send();
        OCS.DynamicScriptLoader.job_manager.script_is_requested(script_url);
    },
    script_loaded: function (script_url, dom_element) {
        if (this.options.debug) {
            console.log('OCS.' + this.class_name + ': ' + script_url + ' loaded!');
        }

        // Reduce the number of pending files
        this.options.loaded.combine([script_url]);
        this.fireEvent('script_loaded', {url: script_url, element: dom_element});
        this.continue_load();
    },
    continue_load: function () {
        this.start();
    },
    complete_run: function () {
        this.fireEvent('complete_run', this, 1);
        this.resolve({result: 'success'});

    },
    is_script_loaded: function (script_url) {
        return this.options.loaded.indexOf(script_url) >= 0;
    },
    set_debug: function (val) {
        this.options.debug = val;
    },
    get_ajax_manager: function () {
        if (!this.ajax_manager) {
            this.ajax_manager = new OCS.Classes.AjaxManager();
        }
        return this.ajax_manager;
    },
    destroy: function() {
        this.removeEvents.delay(10, this);
    }
});